// extracted by mini-css-extract-plugin
export default {"titleContainer":"index_snow_titleContainer__rT-Ff","mobile":"index_snow_mobile__lNBV3","bannerTitle":"index_snow_bannerTitle__x8d2x"};